var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96549 4.93141L5.13849 5.67341C5.24781 6.04759 5.40051 6.40771 5.59349 6.74641C5.79478 7.08264 6.03733 7.39238 6.31549 7.66841L7.38649 7.33841C7.98649 7.15341 8.64149 7.34341 9.04049 7.81841L9.65049 8.54441C9.89747 8.83586 10.0213 9.21201 9.99571 9.59317C9.97014 9.97433 9.79718 10.3306 9.51349 10.5864C8.51849 11.4944 6.98649 11.8014 5.83949 10.9004C4.83096 10.1071 3.97793 9.1341 3.32349 8.03041C2.66739 6.93216 2.22811 5.71821 2.02949 4.45441C1.80949 3.03241 2.85049 1.89441 4.14849 1.50641C4.92249 1.27441 5.74849 1.67241 6.03249 2.41441L6.36749 3.28941C6.58749 3.86541 6.42949 4.51541 5.96549 4.93141Z",
    fill: "#F39200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.1fa668cd16f261549662f2fdc547c148.svg";
export { ForwardRef as ReactComponent };